export default [
  {
    path: '/lot-settlement-list',
    name: 'lot-settlement-list',
    component: () => import(/* webpackChunkName: "finance-routes" */ '@/views/Finance/LotSettlementList'),
    reverse: 'lot-settlement-list',
    meta: { permission: 'api.view_lot' }
  },
  {
    path: '/advances',
    name: 'advance-list',
    component: () => import(/* webpackChunkName: "finance-routes" */ '@/views/Advances/AdvanceList.vue'),
    meta: {
      permission: 'api.view_advance'
    }
  },
  {
    path: '/advances/create',
    name: 'advance-create',
    component: () => import(/* webpackChunkName: "finance-routes" */ '@/views/Advances/AdvanceCreate.vue'),
    meta: { permission: 'api.add_advance' }
  },
  {
    path: '/advances/:id',
    name: 'advance-view',
    component: () => import(/* webpackChunkName: "finance-routes" */ '@/views/Advances/AdvanceView.vue'),
    meta: {
      permission: 'api.view_advance'
    }
  },
  {
    path: '/advances/:id/edit',
    name: 'advance-edit',
    component: () => import(/* webpackChunkName: "finance-routes" */ '@/views/Advances/AdvanceEdit.vue'),
    meta: { permission: 'api.change_advance' }
  }
]
